<template>
  <div>
    <loading :active.sync="isLoading" :is-full-page="fullPage"></loading>
    <Header />

    <div class="container">
      <div class="row">
        <div class="col-md-12 col-sm-12">
          <SecondHeader />
        </div>
      </div>
      <div class="row">
        <div class="col-md-2"></div>
        <div class="col-md-3">
                    <img :src="this.experiences.actionCover + '?' + Date.now()" style="
    width: 250px;
    height: 400px;object-fit: scale-down;">

         </div>
        <div class="col-md-5">
          <div class="row">
            <div class="col-md-12">
              <span class="title_item">Nombre: </span> {{this.experiences.name}}
            </div>
          </div>
          <div class="row">
            <div class="col-md-12">
              <span class="title_item">Palabras Clave: </span>{{this.experiences.keywordsSearch.join(",")}}
            </div>
          </div>
          <div class="row">
            <div class="col-md-12">
              <span class="title_item">Alcance Geográfico: </span> {{this.experiences.geoScope}}
            </div>
          </div>
          <div class="row">
            <div class="col-md-12">
              <span class="title_item">Descripción: </span>  {{this.experiences.description}}
            </div>
          </div> 
             <div class="row" v-if="this.experiences.mitigationUnitacts"> 
            <div class="col-md-12">
              <span class="title_item">Unidad del dato de actividad: </span>  {{this.experiences.mitigationUnitacts.name}}
            </div>
          </div>
             <div class="row" v-if="this.experiences.mitigationUnitacts"> 
            <div class="col-md-12">
              <span class="title_item">Dato de actividad: </span>  {{this.experiences.activityData}}
            </div>
          </div>
             <div class="row" v-if="this.experiences.mitigationPotential"> 
            <div class="col-md-12">
              <span class="title_item">Unidad potencial de mitigación: </span>  {{this.experiences.mitigationPotential.name}}
            </div>
          </div>
             <div class="row" v-if="this.experiences.mitigationPotential"> 
            <div class="col-md-12">
              <span class="title_item">Potencial de mitigación: </span>  {{this.experiences.mitigationPotential}}
            </div>
          </div>
          <div class="row">
            <div class="col-md-12">
              <span class="title_item">Link: </span> <a :href="this.experiences.link.resource" >{{this.experiences.link.resource}}</a>
            </div>
          </div>
        </div>
        <div class="col-md-2"></div>
      </div>
    </div>

    <Footer />
  </div>
</template>


<script>
import Header from "./partials/Header";
import Footer from "./partials/Footer";
import Mapa from "./partials/Mapa";
import HeaderResponsive from "./partials/HeaderResponsive";
import SecondHeader from "./partials/SecondHeaderMitigacion";

import axios from "axios";

import Loading from "vue-loading-overlay";
// Import stylesheet
import "vue-loading-overlay/dist/vue-loading.css";
import config from "../../helpers/config";
import fileName from "../../helpers/fileName";

export default {
  components: {
    Header,
    HeaderResponsive,
    Footer,
    Mapa,
    Loading,
    SecondHeader,
  },
  mounted() {
    this.getMitigation(this.$router.history.current.query.mid);
  },
  data() {
    return {
      experiences: [],
      queryObjetive: [],
      queryLevel: [],
      queryThreat: [],
      link_1: "",
      link_2: "",
      isLoading: true,
      fullPage: true,
      index_view: true,
      detail_view: false,
      code: null,
      departament: null,
      municipality: null,
      name: null,
      longName: null,
      guild: null,
      adaptation: null,
      sub_adaptation: null,
      measure: null,
      responsible_name: null,
      responsible_email: null,
      responsible_phone: null,
      responsible_charge: null,
    };
  },
  methods: {
    lastFileName(name) {
      return fileName(name);
    },

    navigation(experience) {},
    navigation_back() {
      this.index_view = true;
      this.detail_view = false;
    },
    getMitigation(id) {
      const vue = this;
      this.isLoading = true;
      axios
        .get(
          `${config.urlApi}/mitigationActions/${id}?filter[include]=mitigationCategories&filter[include]=mitigationUnitacts&filter[include]=mitigationUnitpots`,
          {}
        )
        .then(({ data }) => {
          this.experiences = data;
          setTimeout(()=>{
                      this.isLoading = false;

          },500)
          return data;
          //PROBLEMA CON TRAERSE LOS FILES, NO SE SEPARARON LAS IMAGENES DE LOS ANEXOS
          //Y POR LO MENOS UNA IMAGEN POR EXPERIENCIA DEBE SUBIRSE
        })
        .then((data) => {
        })
        .then(({ data }) => {})
        .catch(function (error) {});
    },
  },
  computed: {
    getExternalLinks() {
      const newArr = [];

      return [];
    },
       getExternalLinks() {
      const newArr = [];

      return [];
    },
    index_ready() {
      if (this.index_view == true && this.detail_view == false) {
        return true;
      }
    },
    details_ready() {
      if (this.detail_view == true && this.index_view == false) {
        return false;
      }
    },
  },
};
</script>


<style>
body {
  overflow-x: hidden;
}
.title_item {
  color:#3366cc;
    font-weight: bold;
    font-size:20px;

}
.row {
  padding-bottom: 10px;
}
.text_desktop_header_index_container {
  width: 64%;
  line-height: 0.4;
  font-size: 25px;
  font-weight: bolder;
  margin: auto !important;
  position: relative;
  top: 40px;
}
.img_header {
  width: 100% !important;
  height: 480px !important;
}
.img_body {
  width: 100%;
  height: 250px !important;
  margin-bottom: 20px;
}
.img_body_container {
  width: 100%;
  margin: auto;
  margin-top: 20px;
}
.img_body_container > .row > .col-md-9 > p,
.img_body_container > .row > .col-md-12 > p {
  line-height: 0.4;
}
.btn-vermas {
  font-weight: bolder !important;
  color: #3366cc !important;
  text-decoration: underline !important;
  font-size: 20px;
}
.btn-vermas:hover {
  cursor: pointer;
}
.container_img_header {
  margin-top: -110px;
}
@media (max-width: 768px) {
  .img_header,
  .text_desktop_header_index_container {
    display: none;
  }
  .container_img_header {
    margin-top: 0px;
  }
}
</style>
